<template>
  <b-modal id="addPanelModal" title="Добавление пульта" ref="addPanelModal"
           header-bg-variant="primary" header-text-variant="light"
           ok-title="Добавить" cancel-title="Отмена" ok-variant="primary"
           cancel-variant="outline-primary" @ok="onAdd" :ok-disabled="Boolean(idError)"
  >
    <div class="mt-2">Id пульта</div>
    <b-form-input class="mt-2"
        v-model="newPanelId" placeholder="Введите id" type="number"></b-form-input>
    <b-form-invalid-feedback :force-show="Boolean(idError)">
      {{ idError }}
    </b-form-invalid-feedback>
    <div class="mt-2">Название пульта</div>
    <b-form-input class="mt-2"
        v-model="newPanelTitle" placeholder="Введите название"></b-form-input>
  </b-modal>
</template>

<script>
import { mapActions, mapMutations, mapGetters } from 'vuex'

export default {
  name: 'AddPanel',
  data() {
    return {
      newPanelId: null,
      newPanelTitle: null
    }
  },
  mounted() {
    this.getId()
  },
  computed: {
    ...mapGetters({
      panels: 'training/getPanels'
    }),
    panelIds() {
      return new Set(this.panels.map((panel) => Number(panel.id)))
    },
    idError() {
      if (this.newPanelId === null || this.newPanelId === '') {
        return 'id не может быть пустым'
      }
      if (this.panelIds.has(Number(this.newPanelId))) {
        return 'id не может повторяться'
      }
      return false
    }
  },
  methods: {
    ...mapActions({
      updateUpdater: 'contentManager/updateUpdater'
    }),
    ...mapMutations({
      addPanel: 'training/addPanel'
    }),
    getId() {
      let i = 0
      while (this.panelIds.has(i)) {
        i++ // eslint-disable-line no-plusplus
      }
      this.newPanelId = i
    },
    onAdd() {
      this.addPanel({ id: Number(this.newPanelId), name: this.newPanelTitle })
      this.updateUpdater()
      this.newPanelTitle = ''
      this.getId()
    }
  }
}
</script>

<style scoped>

</style>
